<template>
  <div class="row pt-2">
    <div class="col">
      <Button label="Modifier" @click="modifier"/>
    </div>
    <div class="col">
      <Button label="Fermer" @click="fermer"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonBar',
  emits: ['fermer', 'modifier'],
  methods: {
    modifier() {
      this.$emit('modifier');
    },
    fermer() {
      this.$emit('fermer');
    },
  }
}
</script>